import { aboutHighlights, aboutImage, aboutStats, festivalInfo } from "@/mocks/festival";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="reveal">
            <span className="text-xs tracking-[0.24em] text-primary-600">ABOUT FESTIVAL</span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-foreground-950">
              거봉포도의 고장,
              <br />
              입장의 가을을 만나다
            </h2>
            <p className="mt-6 text-sm md:text-base leading-relaxed text-foreground-600">
              2026년 제27회 입장거봉포도축제가 {festivalInfo.dateShort} 이틀간 {festivalInfo.venue}에서 열립니다.
              천안 입장면의 대표 농산물인 거봉포도를 맛보고, 품평회와 시식회, 다채로운 체험 행사와 공연까지
              온 가족이 함께 즐길 수 있는 지역 대표 축제입니다.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-3 md:gap-5">
              {aboutStats.map((stat) => (
                <div key={stat.label} className="rounded-lg bg-background-100 px-3 py-4 md:px-4 md:py-5">
                  <span className="block font-heading text-sm sm:text-lg md:text-2xl text-primary-700">
                    {stat.value}
                    {stat.unit && <span className="text-sm md:text-base">{stat.unit}</span>}
                  </span>
                  <span className="mt-1.5 block text-[11px] md:text-xs leading-relaxed text-foreground-500">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal reveal-delay-2">
            <div className="relative w-full aspect-[4/3] overflow-hidden rounded-lg">
              <img
                src={aboutImage.src}
                alt={aboutImage.alt}
                width={1000}
                height={750}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-4 flex items-start gap-3 rounded-lg bg-accent-50 border border-accent-200/70 px-5 py-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 text-white">
                <i className="ri-map-pin-2-line"></i>
              </span>
              <div>
                <strong className="block text-sm text-foreground-950">{festivalInfo.venue}</strong>
                <span className="text-xs text-foreground-600">{festivalInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {aboutHighlights.map((item, i) => (
            <div
              key={item.no}
              className={`reveal reveal-delay-${i + 1} rounded-lg border border-background-200 bg-background-50 p-6 md:p-7`}
            >
              <span className="font-heading text-2xl text-accent-500">{item.no}</span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}